<template>
  <div>
    <v-card flat>
      <v-card-text>
        <v-row justify="space-around">
          <template v-for="(item, i) in productList">
            <v-hover v-slot="{ hover }" :key="item.Id">
              <v-card width="350" class="mx-2 my-2" :elevation="hover ? 4 : 1">
                <v-img :src="item.PictureUrl" height="200px"></v-img>

                <v-card-title class="text-truncate pt-3">
                  {{ item.Name }}
                </v-card-title>

                <v-card-subtitle class="pb-2">
                  <div class="tdf-text-truncate" v-html="item.Description" />
                </v-card-subtitle>

                <v-row align="center" class="ma-0 px-4 py-2">
                  <div class="text-body-2">
                    {{ $translate('QUANTITY') }}:
                    <span class="text-h6">{{ item.Quantity }}</span>
                  </div>

                  <v-spacer></v-spacer>

                  <v-btn-toggle rounded>
                    <v-btn
                      small
                      @click="decreaseQuantity(i, item)"
                      :disabled="item.Quantity < 1"
                    >
                      <v-icon small>ti-minus</v-icon>
                    </v-btn>
                    <v-btn
                      small
                      @click="increaseQuantity(i, item)"
                      :disabled="item.Quantity >= item.Capacity"
                    >
                      <v-icon small>ti-plus</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </v-row>

                <v-row v-if="showPrice(item)" justify="end" class="ma-0 pa-2">
                  <div class="text-right text--primary">
                    <span
                      v-if="onDiscount(item)"
                      class="discount-price text-body-2 mr-1"
                    >
                      {{ formatter.format(getProductRetailUnitPrice(item)) }}
                    </span>
                    <span
                      class="text-h6"
                      :class="hasGeneralDiscount(item) ? 'red--text' : ''"
                    >
                      {{ formatter.format(getProductUnitPrice(item)) }}
                    </span>
                    <span class="text-caption text--secondary">{{
                      priceSuffix
                    }}</span>
                  </div>
                </v-row>
              </v-card>
            </v-hover>
          </template>
        </v-row>
      </v-card-text>

      <v-card-actions class="pa-3">
        <v-spacer></v-spacer>
        <v-btn
          min-width="200"
          @click="onBookBtnClick"
          color="primary"
          class="primary-font-color"
          dark
        >
          {{ $translate('BOOK') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import utility from '@/shared/utility';
import {
  hasGeneralDiscount,
  personalDiscount,
  getUnitPrice,
  getRetailUnitPrice,
  applyPersonalDiscount,
} from '@/objects/Product';

export default {
  name: 'MultipleProductsOrder',
  props: {
    productList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    selectedProducts() {
      if (this.productList == null) {
        return [];
      }

      return this.productList.filter((item) => item.Quantity > 0);
    },
    isProfUser() {
      return this.$store.getters.isProfUser;
    },
    priceSuffix() {
      if (this.isProfUser) {
        return this.$translate('EXCL_VAT');
      }
      return '';
    },
  },
  data() {
    return {
      formatter: new Intl.NumberFormat('nl', {
        style: 'currency',
        currency: 'EUR',
      }),
    };
  },
  methods: {
    decreaseQuantity(index, item) {
      const newValue = this.productList[index].Quantity - 1;
      const itemNew = item;
      itemNew.Quantity = newValue;
      this.$set(this.productList, index, itemNew);
    },
    increaseQuantity(index, item) {
      const newValue = this.productList[index].Quantity + 1;
      const itemNew = item;
      itemNew.Quantity = newValue;
      this.$set(this.productList, index, itemNew);
    },
    onBookBtnClick() {
      this.$emit('book', {
        Products: this.selectedProducts,
      });
    },
    hasGeneralDiscount,
    onDiscount(item) {
      // General discount check
      if (hasGeneralDiscount(item)) {
        return true;
      }

      // Personal discount check
      if (personalDiscount(item) > 0) {
        return true;
      }

      return false;
    },
    getProductUnitPrice(item) {
      let price = getUnitPrice(item);
      if (applyPersonalDiscount(item)) {
        price = utility.getDiscountPrice(price, personalDiscount(item));
      }
      return price;
    },
    getProductRetailUnitPrice(item) {
      if (hasGeneralDiscount(item)) {
        return getRetailUnitPrice(item);
      }
      return getUnitPrice(item);
    },
    showPrice(item) {
      if (item.Type === 'Rental' && this.getProductUnitPrice(item) < 0.005) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.tdf-text-truncate {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 2px;
  height: 2.8rem;
}
</style>
